import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { IS_NOT_EMPTY } from 'cargo-chief-commons';
import { UtilService } from '@service/util/util.service';

@Component({
	selector: 'app-pricing-feedback-dialog',
	templateUrl: './pricing-feedback-dialog.component.html',
	styleUrls: ['./pricing-feedback-dialog.component.scss'],
})
export class PricingFeedbackDialogComponent implements OnInit {
	priceFeedbackForm: UntypedFormGroup;
	rateSources = ['Historical Data', 'Core Carrier', 'Rating Service'];
	ratingServices = ['DAT RateView', 'TruckStop RateMate', 'Other'];
	isPriceNotAccurate = null;
	showRateType = true;

	constructor(
		public dialogRef: MatDialogRef<PricingFeedbackDialogComponent>,
		public utilService: UtilService,
		private _formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) public data: { openedManually: boolean; rateType: null }
	) {}

	ngOnInit() {
		this.priceFeedbackForm = this._formBuilder.group({
			rateType: [null, Validators.required],
			hasRate: null,
			currentRate: '',
			rateSource: '',
			ratingService: '',
		});
		if (IS_NOT_EMPTY(this.data.rateType)) {
			this.priceFeedbackForm.get('rateType').setValue(this.data.rateType);
			this.showRateType = false;
		}
	}

	closeDialog(): void {
		this.dialogRef.close();
	}

	submit({ feedbackData, feedbackType }) {
		this.dialogRef.close({ feedbackData, feedbackType });
	}

	showRatingServiceInput(): boolean {
		return (
			this.priceFeedbackForm.get('hasRate').value == 'true' &&
			this.priceFeedbackForm.get('rateSource').value == 'Rating Service'
		);
	}

	showAutomaticPromptQuestion() {
		return !this.data.openedManually && this.utilService.isNullOrUndefined(this.isPriceNotAccurate);
	}
}
